import { render, staticRenderFns } from "./Form154_v2.vue?vue&type=template&id=20d88ed0&scoped=true&"
import script from "./Form154_v2.vue?vue&type=script&lang=js&"
export * from "./Form154_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form154_v2.vue?vue&type=style&index=0&id=20d88ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d88ed0",
  null
  
)

export default component.exports